// import { errorMessage } from "@components/forms/error";
import {
  AdminUserTypes,
  BaseUserInfoUpdateRequest,
  MerchantUserInfoUpdateRequest,
  TraderUserInfoUpdateRequest,
  UserInfoUpdateRequest,
} from "@features/admin/users/api";
import * as yup from "yup";

const baseUpdateSchema: yup.ObjectSchema<BaseUserInfoUpdateRequest> = yup
  .object()
  .shape({
    status: yup.string(),
    roles: yup.array().of(yup.string().required()),
    referrer_email: yup.string().email().optional(),
  });

export const traderUpdateSchema: yup.ObjectSchema<TraderUserInfoUpdateRequest> =
  baseUpdateSchema.shape({
    // allow_farm_creation: boolean;
    // allow_requisites_without_device: boolean;
    // boosted: boolean;
    commission_config: yup.object().shape({
      commission_sbp: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        )
        .required(),
      commission_card: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        )
        .required(),
      commission_account_number: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        )
        .required(),
      commission_ibt: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        )
        .required(),
    }),
    min_sum_order: yup.number().required(),
    max_sum_order: yup.number().required().min(yup.ref("min_sum_order")),
    min_sum_pay_out_order: yup.number().required(),
    max_sum_pay_out_order: yup
      .number()
      .required()
      .when("roles", {
        is: (val: string[]) => val.includes("trader"),
        then: (schema) =>
          schema.when("boosted", {
            is: false,
            then: (schema) => schema.max(100000),
          }),
      }),
    pay_in: yup.bool().required(),
    pay_out: yup.bool().required(),
    team_lead_commission_pay_in: yup.number(),
    kind: yup.string().oneOf([AdminUserTypes.Trader]).required(),
    boosted: yup.bool().required(),
    allow_farm_creation: yup.bool().required(),
    allow_requisites_without_device: yup.bool().required(),
  });

export const merchantUpdateSchema: yup.ObjectSchema<MerchantUserInfoUpdateRequest> =
  baseUpdateSchema.shape({
    kind: yup.string().oneOf([AdminUserTypes.Merchant]).required(),
    commission_config: yup.object().shape({
      commission_sbp: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        )
        .required(),
      commission_card: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        )
        .required(),
      commission_account_number: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        )
        .required(),
      commission_ibt: yup
        .array()
        .of(
          yup.object().shape({
            min_amount: yup.number().required(),
            max_amount: yup.number().required(),
            rate: yup.number().required(),
          })
        ).required(),
    }),
    min_sum_order: yup.number().required(),
    max_sum_order: yup.number().required().min(yup.ref("min_sum_order")),
    min_sum_pay_out_order: yup.number().required(),
    max_sum_pay_out_order: yup
      .number()
      .required()
      .when("roles", {
        is: (val: string[]) => val.includes("trader"),
        then: (schema) =>
          schema.when("boosted", {
            is: false,
            then: (schema) => schema.max(100000),
          }),
      }),
    pay_in: yup.bool().required(),
    pay_out: yup.bool().required(),
    team_lead_commission_pay_in: yup.number(),
    commission_for_trader_pay_out: yup.number(),
    commission_withdrawal: yup.number(),
    commission_pay_out: yup.number().required(),
  });

export const leaderUpdateSchema: yup.ObjectSchema<UserInfoUpdateRequest> =
  baseUpdateSchema.shape({
    kind: yup.string().oneOf([AdminUserTypes.Lead]).required(),
    commission_withdrawal: yup.number(),
  });

export const getUpdateSchema = (
  role: string
): yup.ObjectSchema<UserInfoUpdateRequest> => {
  if (role == "trader") return traderUpdateSchema;
  if (role == "merchant") return merchantUpdateSchema;

  // fallback – only base fields are required
  return baseUpdateSchema as yup.ObjectSchema<UserInfoUpdateRequest>;
};
